/** 휠복원점검 §4·§5·§6 — 선택지·사진 partCode */

export const KCWA_ORGANIZATION_NAME = '한국자동차휠수리복원협회';
export const KCWA_CUSTOMER_CENTER_PHONE = '1877-2449';

export const WHEEL_POSITIONS = [
  { code: 'FL', label: '운전석 앞 (FL)' },
  { code: 'FR', label: '조수석 앞 (FR)' },
  { code: 'RL', label: '운전석 뒤 (RL)' },
  { code: 'RR', label: '조수석 뒤 (RR)' },
];

/** §5 검사항목 결과 열 — 휠 위치 다중 선택 */
export const WHEEL_POSITION_CHECK_OPTIONS = WHEEL_POSITIONS.map(({ code, label }) => ({
  value: code,
  label: label.replace(/ \(.*\)/, ''),
}));

export const WHEEL_INSURANCE_OPTIONS = [
  { label: '보험처리', value: 'Y' },
  { label: '보험미처리', value: 'N' },
  { label: '재제조부품(OEM)', value: 'OEM' },
  { label: '중고품', value: 'USED' },
];

export const WHEEL_INSURANCE_VALUES = WHEEL_INSURANCE_OPTIONS.map(
  (option) => option.value
);

export const WHEEL_TYPE_OPTIONS = [
  { label: '도장 휠', value: 'PAINTED' },
  { label: '스퍼터링 휠', value: 'SPUTTERING' },
  { label: '커팅 휠', value: 'CUTTING' },
  { label: '크롬 휠', value: 'CHROME' },
  { label: '사제 3피스', value: 'AFTERMARKET_3PC' },
  { label: '법핑 휠', value: 'BUFFING' },
];

export const WHEEL_RESTORATION_METHOD_OPTIONS = [
  { label: '교환', value: 'EXCHANGE' },
  { label: '도장', value: 'PAINT' },
  { label: '커팅', value: 'CUTTING' },
  { label: '색상변경', value: 'COLOR_CHANGE' },
  { label: '용접', value: 'WELDING' },
];

export const WHEEL_CLEAR_COAT_OPTIONS = [
  { label: '분체', value: 'POWDER' },
  { label: '액상', value: 'LIQUID' },
];

export const WHEEL_PRECISION_METHOD_OPTIONS = [
  { label: '비파괴', value: 'NDT' },
  { label: '열·X선', value: 'THERMAL_XRAY' },
  { label: '육안', value: 'VISUAL' },
];

export const WHEEL_YES_NO_OPTIONS = [
  { label: '없음', value: 'N' },
  { label: '있음', value: 'Y' },
];

/** GOOD(구 양호)=없음, BAD(구 불량)=있음 — 입력·리포트 공통 */
export const WHEEL_GOOD_BAD_OPTIONS = [
  { label: '없음', value: 'GOOD' },
  { label: '있음', value: 'BAD' },
];

/** 양호/불량 (GOOD/BAD) — 안전검사·위치별 상세 공통 */
export const WHEEL_CONDITION_OPTIONS = [
  { label: '양호', value: 'GOOD' },
  { label: '불량', value: 'BAD' },
];

export const WHEEL_CRACK_OPTIONS = [
  { label: '없음', value: 'GOOD' },
  { label: '있음', value: 'BAD' },
  { label: '용접', value: 'WELD' },
];

export const WHEEL_BENDING_OPTIONS = [
  { label: '있음', value: 'YES' },
  { label: '없음', value: 'NONE' },
  { label: '수리요망', value: 'REPAIR' },
];

export const WHEEL_LOCATION_ITEMS = [
  { key: 'crack', title: '크렉 (균열/파손)', criteria: '(2cm이하)', options: WHEEL_CRACK_OPTIONS },
  {
    key: 'bending',
    title: '굴절 (변형/뒤틀림)',
    criteria: '(-2.5mm~+2.5mm)',
    options: WHEEL_BENDING_OPTIONS,
  },
  { key: 'balance', title: '바란스 (회전 균형)', criteria: '', options: WHEEL_CONDITION_OPTIONS },
  { key: 'paint', title: '도색', criteria: '', options: WHEEL_CONDITION_OPTIONS },
  { key: 'clearCoat', title: '크리어 코트', criteria: '', options: WHEEL_CONDITION_OPTIONS },
  {
    key: 'cuttingPart',
    title: '컷팅 부분',
    criteria: '(0.6mm 이하)',
    options: WHEEL_GOOD_BAD_OPTIONS,
  },
  {
    key: 'alignment',
    title: '휠 타이어 노면력 측정',
    criteria: '',
    options: WHEEL_CONDITION_OPTIONS,
    manualOnly: true,
  },
];

/** 위치별 상세점검 — 자동 기본값 채우기 제외 (수동 선택만) */
export const WHEEL_LOCATION_MANUAL_ONLY_KEYS = WHEEL_LOCATION_ITEMS.filter(
  (item) => item.manualOnly
).map((item) => item.key);

export function formatWheelLocationItemTitle({ title, criteria }) {
  if (!criteria) return title;
  return `${title} ${criteria}`;
}

/** §6 — 사진 연동 항목 (크랙·굴절·바란스·도색, 위치별 4장) */
export const WHEEL_LOCATION_PHOTO_KEYS = ['crack', 'bending', 'balance', 'paint'];

export const WHEEL_LOCATION_PHOTO_LABELS = {
  crack: '크랙',
  bending: '굴절',
  balance: '바란스',
  paint: '도색',
};

export const WHEEL_PHOTO_PART = {
  PRE_PLATE: 'WHEEL_PRE_PLATE',
};

export const prePhotoPart = (position) => `WHEEL_PRE_${position}`;

export const WHEEL_PHOTO_TYPE = {
  WHEEL_PRE_PLATE: '복원전-차량번호',
  WHEEL_PRE_FL: '복원전 (운전석 앞)',
  WHEEL_PRE_FR: '복원전 (조수석 앞)',
  WHEEL_PRE_RL: '복원전 (운전석 뒤)',
  WHEEL_PRE_RR: '복원전 (조수석 뒤)',
  WHEEL_LOC_FL_CRACK: '크랙 (FL)',
  WHEEL_LOC_FL_BENDING: '굴절 (FL)',
  WHEEL_LOC_FL_BALANCE: '바란스 (FL)',
  WHEEL_LOC_FL_PAINT: '도색 (FL)',
  WHEEL_LOC_FR_CRACK: '크랙 (FR)',
  WHEEL_LOC_FR_BENDING: '굴절 (FR)',
  WHEEL_LOC_FR_BALANCE: '바란스 (FR)',
  WHEEL_LOC_FR_PAINT: '도색 (FR)',
  WHEEL_LOC_RL_CRACK: '크랙 (RL)',
  WHEEL_LOC_RL_BENDING: '굴절 (RL)',
  WHEEL_LOC_RL_BALANCE: '바란스 (RL)',
  WHEEL_LOC_RL_PAINT: '도색 (RL)',
  WHEEL_LOC_RR_CRACK: '크랙 (RR)',
  WHEEL_LOC_RR_BENDING: '굴절 (RR)',
  WHEEL_LOC_RR_BALANCE: '바란스 (RR)',
  WHEEL_LOC_RR_PAINT: '도색 (RR)',
};

/** 휠 사진 업로드 압축 옵션 */
export const WHEEL_PHOTO_COMPRESS_OPTIONS = {
  maxSizeMB: 0.5,
  maxWidthOrHeight: 1280,
  useWebWorker: true,
};

/** §4 위치별 복원 전 사진 (1장) */
export const WHEEL_PRE_PHOTOS_PER_POSITION = 1;
export const WHEEL_PRE_MAX_PHOTOS = 5;
export const WHEEL_RESTORATION_METHOD_MAX = 4;

export const locationPhotoPart = (position, key) => {
  const suffix = {
    crack: 'CRACK',
    bending: 'BENDING',
    balance: 'BALANCE',
    paint: 'PAINT',
  }[key];
  return suffix ? `WHEEL_LOC_${position}_${suffix}` : null;
};

/** §6 사진 영역 표시 조건 */
export function shouldShowLocationPhoto(key, value) {
  if (!value) return false;
  if (key === 'crack') return value === 'BAD' || value === 'WELD';
  if (key === 'bending' || key === 'balance' || key === 'paint') {
    if (key === 'bending') return value === 'YES' || value === 'REPAIR';
    return value === 'BAD';
  }
  return false;
}
